import { BaseModel, attr, belongsTo, hasMany } from "../../lib/itn-ui-kit/data";

export default class KPIDashboardModel extends BaseModel {
  @attr("string") performanceText;
  @attr("string") summary;
  @belongsTo("kpi-percentage") percentageScore;
  @hasMany("kpi-metric-info") cells;
}
